import { lazy } from 'react';
import { melioIcon } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';

export const BASE_PATH = '/agent-builder';

const MainView = lazy(
  () => import(/* webpackChunkName: "AgentBuilderRoutes" */ '../pages/MainView')
);

export const agentBuilderRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BASE_PATH, `${BASE_PATH}/*`]
    },
    {
      name: 'Agent builder',
      path: `${BASE_PATH}/main`,
      component: MainView,
      exact: false,
      icon: melioIcon,
      pages: []
    }
  ]
};
